/*global math, Algebrite*/

/**
 * Element_Fraction hérite de Fraction
 * Les méthodes statiques add et d'instance add sont nécessaires pour que math.add avec deux instances Element_Fraction fonctionnent
 * et également qu'en cas de non gestion d'opération au niveau de cette classe c'est celle de Fraction qui prendra le relai
 */

import { Fraction } from "mathjs";

export class Element_Fraction extends Fraction {
  isNonReduced = true;
  _originalS;
  _originalN;
  _originalD;

  constructor(n, d) {
    console.log("Element_Fraction constructor");
    super(n, d);
    this._originalS = math.sign(n) * math.sign(d);
    this._originalN = math.abs(n);
    this._originalD = math.abs(d);
    this.isNonReduced = true;
  }

  // Méthode statique pour l'addition
  static add(a, b) {
    if (a instanceof Fraction && b instanceof Fraction) {
      console.log("Element_Fraction add");
      const numerator = math.add(
        math.multiply(
          a._originalS ?? a.s,
          a._originalN ?? a.n,
          b._originalD ?? b.d
        ),
        math.multiply(
          b._originalS ?? b.s,
          b._originalN ?? b.n,
          a._originalD ?? a.d
        )
      );
      const denominator = math.multiply(
        a._originalD ?? a.d,
        b._originalD ?? b.d
      );
      return new Element_Fraction(numerator, denominator);
    } else {
      return super.add(numerator, denominator);
    }
  }

  static subtract(a, b) {
    return Element_Fraction.sub(a, b);
  }

  // Méthode statique pour la soustraction
  static sub(a, b) {
    if (a instanceof Fraction && b instanceof Fraction) {
      console.log("Element_Fraction subtract");
      const numerator = math.subtract(
        math.multiply(
          a._originalS ?? a.s,
          a._originalN ?? a.n,
          b._originalD ?? b.d
        ),
        math.multiply(
          b._originalS ?? b.s,
          b._originalN ?? b.n,
          a._originalD ?? a.d
        )
      );
      const denominator = math.multiply(
        a._originalD ?? a.d,
        b._originalD ?? b.d
      );
      return new Element_Fraction(numerator, denominator);
    } else {
      return super.sub(numerator, denominator);
    }
  }

  static multiply(a, b) {
    return Element_Fraction.mul(a, b);
  }
  // Méthode statique pour la multiplication
  static mul(a, b) {
    if (a instanceof Fraction && b instanceof Fraction) {
      console.log("Element_Fraction multiply");
      const numerator = math.multiply(
        a._originalS ?? a.s,
        b._originalS ?? b.s,
        a._originalN ?? a.n,
        b._originalN ?? b.n
      );
      const denominator = math.multiply(
        a._originalD ?? a.d,
        b._originalD ?? b.d
      );
      return new Element_Fraction(numerator, denominator);
    } else {
      return super.mul(numerator, denominator);
    }
  }

  static divide(a, b) {
    return Element_Fraction.div(a, b);
  }
  // Méthode statique pour la division
  static div(a, b) {
    if (a instanceof Fraction && b instanceof Fraction) {
      console.log("Element_Fraction divide");
      const numerator = math.multiply(
        a._originalS ?? a.s,
        b._originalS ?? b.s,
        a._originalN ?? a.n,
        b._originalD ?? b.d
      );
      const denominator = math.multiply(
        a._originalD ?? a.d,
        b._originalD ?? b.d
      );
      return new Element_Fraction(numerator, denominator);
    } else {
      return super.div(numerator, denominator);
    }
  }

  // Méthodes d'instance
  add(other) {
    return Element_Fraction.add(this, other);
  }

  sub(other) {
    return Element_Fraction.subtract(this, other);
  }

  mul(other) {
    return Element_Fraction.multiply(this, other);
  }

  div(other) {
    return Element_Fraction.divide(this, other);
  }

  toTex() {
    return this.toLatex();
  }

  toLatex() {
    
    let str = `\\dfrac{${this._originalN ?? this.n}}{${
      this._originalD ?? this.d
    }}`;
    let sign = this._originalS ?? this.s;
    return sign < 0 ? `-${str}` : str;
  }
}
